/*!
 * Roundway Quiz Nav — injects a forest pill with an apothecary compass icon
 * immediately before the header search icon, linking to /pages/health-quiz.
 *
 * Theme-agnostic: it locates the search icon by a list of candidate selectors, then
 * inserts the pill as the search icon's previous sibling so it sits to its left.
 * Runs on DOM ready plus a MutationObserver pass so sticky/duplicated headers
 * (Dawn renders a desktop and a mobile header) both get one pill each.
 */
(function () {
  'use strict';

  var HREF = '/pages/health-quiz';
  var LABEL = 'Find your match';
  var MOBILE_BREAKPOINT = 989;

  var ICON =
    '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
      // outer apothecary ring
      '<circle cx="16" cy="16" r="12.2" stroke="currentColor" stroke-width="1.5"/>' +
      // tick marks at the cardinals
      '<path d="M16 3.4v3M16 25.6v3M3.4 16h3M25.6 16h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      // needle: leaf on one end, point on the other
      '<g class="rwq-nav-link__needle">' +
        '<path d="M11.2 20.8 20.8 11.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M20.8 11.2c-1 3.2-2.1 4.7-4.2 5.4 0.7-2.1 2.2-3.2 4.2-5.4Z" fill="currentColor"/>' +
        '<path d="M11.2 20.8c1-3.2 2.1-4.7 4.2-5.4-0.7 2.1-2.2 3.2-4.2 5.4Z" fill="currentColor" opacity="0.55"/>' +
      '</g>' +
      '<circle cx="16" cy="16" r="1.5" fill="currentColor"/>' +
    '</svg>';

  // Search icon candidates across common themes. The pill sits immediately
  // BEFORE the search icon (to its left on LTR headers).
  var SEARCH_SELECTORS = [
    '.header__icon--search',            // Dawn (summary/a inside modal opener)
    '.header__search',                  // Dawn wrapper
    '.search-modal__form',              // Dawn modal opener container
    '.header .search-modal',
    '.site-header__search',             // Debut / older
    '.site-header__search-icon',
    '.header-search',
    '[data-search-toggle]',
    '[data-search-modal]',
    'header [aria-label*="Search" i]',
    'header a[href*="/search"]',
  ];

  // Containers where a "search" match is NOT the header icon — the open search
  // overlay, predictive search, drawers and dialogs. Pills must never render
  // inside these (they duplicate and overlap results).
  var EXCLUDE_WITHIN =
    '.search-modal__content, .search-modal, .predictive-search, .predictive-search-wrapper, ' +
    'predictive-search, dialog, [role="dialog"], .modal, .drawer, [id*="search-modal" i], ' +
    '[class*="predictive" i], [class*="search-overlay" i], [class*="search-drawer" i]';

  function findSearchIcons() {
    var out = [];
    SEARCH_SELECTORS.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(nodes, function (n) {
        // Skip anything inside an open search overlay / modal / drawer.
        if (n.closest && n.closest(EXCLUDE_WITHIN)) return;
        // Normalise: if we matched an svg/img, climb to its clickable parent.
        var node = n;
        if (node.tagName === 'SVG' || node.tagName === 'IMG') {
          node = node.closest('a,button,summary,[role="button"]') || node;
        }
        if (node.closest && node.closest(EXCLUDE_WITHIN)) return;
        if (out.indexOf(node) === -1) out.push(node);
      });
    });
    return out;
  }

  function build(pulse) {
    var a = document.createElement('a');
    a.className = 'rwq-nav-link' + (pulse ? ' rwq-nav-link--pulse' : '');
    a.href = HREF;
    a.setAttribute('data-rwq-nav', '1');
    a.setAttribute('aria-label', LABEL + ' — take the 60 second quiz');
    a.innerHTML =
      '<span class="rwq-nav-link__icon">' + ICON + '</span>' +
      '<span class="rwq-nav-link__label">' + LABEL + '</span>';
    a.addEventListener('click', function () {
      try {
        if (window.dataLayer) window.dataLayer.push({ event: 'rwq_nav_click' });
        sessionStorage.setItem('rw_quiz_entry', 'nav');
      } catch (e) {}
    });
    return a;
  }

  function quizLinkExistsWithin(root) {
    if (!root || !root.querySelectorAll) return false;
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (/\/pages\/(health-quiz|find-your-match)(?:[?#]|$)/.test(href)) return true;
    }
    return false;
  }

  // The theme renders the burger drawer markup up front and keeps it
  // display:none until it opens, so we must NOT require visibility here —
  // that was why no quiz row ever appeared in the mobile menu.
  function mobileDrawerNav() {
    return document.querySelector(
      '#site-menu-sidebar mobile-navigation, #site-menu-sidebar, mobile-navigation, .menu-drawer__navigation, .mobile-nav, [data-mobile-menu]'
    );
  }

  function addMobileMenuLink() {
    var drawer = mobileDrawerNav();
    if (!drawer) return false;
    if (drawer.querySelector('[data-rwq-mobile-nav]')) return true;
    if (quizLinkExistsWithin(drawer)) return true;
    var list = drawer.querySelector('ul.link-list') || drawer.querySelector('ul, ol');
    if (!list) return false;
    var existingItem = list.querySelector(':scope > li');
    var item = document.createElement(existingItem ? existingItem.tagName : 'li');
    item.setAttribute('data-rwq-mobile-nav', '1');
    if (existingItem) item.className = existingItem.className;
    var existingLink = existingItem && existingItem.querySelector('a');
    var link = document.createElement('a');
    link.href = HREF;
    link.setAttribute('aria-label', LABEL + ' quiz');
    if (existingLink) link.className = existingLink.className;
    // Mirror the theme's nested span markup so the row inherits its styling.
    link.innerHTML = '<span><span>' + LABEL + '</span></span>';
    item.appendChild(link);
    // Sit above the account row when the theme appends one.
    var accountItem = list.querySelector('#menu-item-account');
    if (accountItem) list.insertBefore(item, accountItem);
    else list.appendChild(item);
    return true;
  }

  var pulsed = false;

  function attach(icon) {
    if (!icon || !icon.parentNode) return false;
    var parent = icon.parentNode;
    // One pill per header container.
    if (parent.querySelector(':scope > [data-rwq-nav]')) return false;
    var pill = build(!pulsed);
    pulsed = true;
    parent.classList.add('rwq-nav-host');
    // Insert immediately before the search icon.
    parent.insertBefore(pill, icon);
    return true;
  }

  function run() {
    var icons = findSearchIcons();
    if (!icons.length) return false;
    var added = false;
    var seenHeaders = [];
    // Only attach to icons that are actually laid out (skips hidden duplicates).
    icons.forEach(function (icon) {
      var box = icon.getBoundingClientRect ? icon.getBoundingClientRect() : null;
      if (box && box.width === 0 && box.height === 0) return;
      // One pill per header bar — a theme can render several search-icon
      // candidates (desktop/mobile/sticky wrappers) but hidden duplicates are
      // already filtered by the rect check above.
      var bar = icon.closest('.header-wrapper, .header, header, .shopify-section') || icon.parentNode;
      if (seenHeaders.indexOf(bar) !== -1) return;
      if (bar && bar.querySelector && bar.querySelector('[data-rwq-nav]')) { seenHeaders.push(bar); return; }
      if (attach(icon)) { seenHeaders.push(bar); added = true; }
    });
    return added;
  }

  function boot() {
    run();
    // Re-run for sticky headers / section re-renders, then stop watching.
    var tries = 0;
    var obs = new MutationObserver(function () {
      tries++;
      run();
      if (tries > 40) obs.disconnect();
    });
    var header = document.querySelector('#shopify-section-header') || document.querySelector('header') || document.body;
    if (header) obs.observe(header, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
    // The desktop pill is hidden on phones, so the same destination must exist
    // inside the burger drawer. The drawer markup is present from first paint,
    // so insert straight away and retry briefly for late section renders.
    addMobileMenuLink();
    var navTries = 0;
    var navTimer = setInterval(function () {
      navTries++;
      if (addMobileMenuLink() || navTries > 20) clearInterval(navTimer);
    }, 250);
    document.addEventListener('click', function () {
      setTimeout(addMobileMenuLink, 120);
    }, true);
    // Shopify section re-render (theme editor) hook.
    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
